import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export type ChartType = 'costsVsSales' | 'stockout' | 'none';

const chartDataURLs: Record<ChartType, string> = {
  costsVsSales: '/admin/capital/inventory-offer',
  stockout: '/admin/capital/missed-sale-offer',
  none: '',
} as const;

export const chartVersions: Record<ChartType, number> = {
  costsVsSales: 1,
  stockout: 2,
  none: 0,
} as const;

export function useSnapshotChartData(chartType: ChartType) {
  return useQuery({
    queryKey: ['snapshotChartData'],
    queryFn: async () => {
      if (chartDataURLs[chartType] === '') return null;
      const response = await axios.get(chartDataURLs[chartType]);
      return response.data;
    },
    retry: false,
    cacheTime: Infinity,
    refetchOnMount: false,
  });
}
